<template>
  <div>
    <Devoffline/>
  </div>
</template>

<script>
// @ is an alias to /src
import Devoffline from 'place/home/devoffline.vue'

export default {
  name: 'home',
  components: {
    Devoffline
  }
}
</script>
